import { FC } from "react";
import Support from "./components/Support";

export const SupportPage: FC = () => {
	return (
		<>
			<Support />
		</>
	);
};
